import * as v from "valibot";
import { createFileRoute } from "@tanstack/react-router";
import { site } from "../config";
import { localisedLinks } from "../seo";

const searchParamsSchema = v.object({});

export const Route = createFileRoute("/$locale/$currency/payment")({
  component: () => null,
  validateSearch: searchParamsSchema,
  head: ({ match, params }) => ({
    meta: [
      { title: site.title },
      { name: "description", content: site.description },
    ],
    links: localisedLinks(match.pathname, params.locale, params.currency),
  }),
});
